"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _BrowserTest = require("../../utils/BrowserTest");

var _DomEvents = require("../../utils/DomEvents");

var _tshirtSize = require("../../utils/propTypes/tshirtSize");

var _CheckboxConstants = require("../CheckboxConstants");

var ToggleInputWrapper = (0, _react.forwardRef)(function (props, ref) {
  var alignment = props.alignment,
      checked = props.checked,
      children = props.children,
      childWrapperId = props.childWrapperId,
      className = props.className,
      description = props.description,
      descriptionId = props.descriptionId,
      descriptionLayout = props.descriptionLayout,
      disabled = props.disabled,
      indicator = props.indicator,
      inline = props.inline,
      input = props.input,
      labelClassName = props.labelClassName,
      onChange = props.onChange,
      readOnly = props.readOnly,
      size = props.size,
      rest = (0, _objectWithoutProperties2.default)(props, ["alignment", "checked", "children", "childWrapperId", "className", "description", "descriptionId", "descriptionLayout", "disabled", "indicator", "inline", "input", "labelClassName", "onChange", "readOnly", "size"]);
  var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);
  return _react.default.createElement("div", Object.assign({}, rest, {
    className: (0, _classnames.default)(className, _CheckboxConstants.ALIGNMENT_CLASSES[alignment], _CheckboxConstants.SIZE_OPTIONS[shorthandSize], disabled && 'private-checkbox--disabled', readOnly && 'private-checkbox--readonly', inline && 'private-checkbox--inline', description && descriptionLayout === 'vertical' && 'private-checkbox--stack-contents'),
    ref: ref
  }), _react.default.createElement("label", {
    className: (0, _classnames.default)('private-checkbox__label', labelClassName),
    onClick: function onClick(evt) {
      if ((0, _BrowserTest.isFirefox)() && (0, _DomEvents.isModifierPressed)(evt)) {
        onChange(Object.assign({}, evt, {
          type: 'change',
          target: {
            checked: !checked
          }
        }));
      }
    }
  }, _react.default.createElement("span", {
    className: "private-checkbox__inner"
  }, input, indicator, children && _react.default.createElement("span", {
    className: 'private-checkbox__text' + (shorthandSize === 'sm' ? " private-checkbox__text--small" : ""),
    id: childWrapperId
  }, children))), description && _react.default.createElement("span", {
    className: "private-checkbox__desc",
    id: descriptionId
  }, description));
});
ToggleInputWrapper.displayName = 'ToggleInputWrapper';

if (process.env.NODE_ENV !== 'production') {
  ToggleInputWrapper.propTypes = {
    alignment: _propTypes.default.string.isRequired,
    checked: _propTypes.default.bool,
    children: _propTypes.default.node,
    childWrapperId: _propTypes.default.string,
    className: _propTypes.default.string,
    description: _propTypes.default.node,
    descriptionId: _propTypes.default.string.isRequired,
    descriptionLayout: _propTypes.default.string.isRequired,
    disabled: _propTypes.default.bool,
    indicator: _propTypes.default.node.isRequired,
    inline: _propTypes.default.bool,
    input: _propTypes.default.node.isRequired,
    labelClassName: _propTypes.default.string,
    onChange: _propTypes.default.func,
    readOnly: _propTypes.default.bool,
    size: _propTypes.default.string
  };
}

var _default = ToggleInputWrapper;
exports.default = _default;
module.exports = exports.default;